import { CurrentKycDtoStatus, CurrentOnboardingDtoStatus } from "@token/shared";
import type {
  CurrentKycDtoStatus as CurrentKycDtoStatusValue,
  CustomerDto,
  KycDtoStatus as KycDtoStatusValue,
} from "@token/shared";
import type { RouteLocationRaw } from "vue-router";

export type CustomerFlowRouteName = "onboarding" | "kyc-status" | "token-purchase";

export function routeForCustomer(customer: Pick<CustomerDto, "kyc" | "onboarding">): RouteLocationRaw {
  return { name: customerFlowRouteName(customer) };
}

export function routeForKycStatus(status: CurrentKycDtoStatusValue | null | undefined): RouteLocationRaw {
  return { name: routeNameForKycStatus(status) };
}

export function customerFlowRouteName(customer: Pick<CustomerDto, "kyc" | "onboarding">): CustomerFlowRouteName {
  const onboardingStatus = customer.onboarding?.status ?? customer.onboarding?.onboarding?.status;
  if (onboardingStatus !== CurrentOnboardingDtoStatus.DONE) return "onboarding";
  return routeNameForKycStatus(customer.kyc?.kyc?.status ?? customer.kyc?.status);
}

function routeNameForKycStatus(
  status: CurrentKycDtoStatusValue | KycDtoStatusValue | null | undefined,
): CustomerFlowRouteName {
  const currentStatus = status ?? CurrentKycDtoStatus.NOT_STARTED;
  if (currentStatus === CurrentKycDtoStatus.APPROVED) return "token-purchase";
  return "kyc-status";
}
